import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
//import { SettingService } from '../services/settingService/setting.service';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { ToastrService } from 'ngx-toastr';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ConfirmDialogModel, ConfirmDialogComponent } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ReportService } from '../services/reportService/report.service';
import { RoleLevel } from '../services/reportService/setting.enum';

@Component({
  selector: 'app-manage-FormUseReports',
  templateUrl: './manage-FormUseReports.component.html',
  styleUrls: ['./manage-FormUseReports.component.scss']
})

export class ManageFormUseReportComponent implements OnInit {

  formDialog: FormGroup;
  updateformDialog: FormGroup;

  pageModelData = {
    pageIndex: 0,
    pageSize: 10,
    searchValue: '',
    OfficeIDList: [],
    officeID: 0
  };

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  currentUser: any;
  organizationId: string;
  responseHolder: any;
  folderList: any[] = [];
  value = '';
  paginatorTotalLength: any;
  //dataSource: any;
  dataCount: any;
  pageChangeEvent: any;
  pageIndex: any;
  pageSize: any;

  OfficeIDList: any = [];
  myOfficeID: any;
  ShowNoRecordFound: boolean = false;
  spinner: boolean = false;
  taskStatusID: number = 0;

  cType: number = 1;
  CoreShowName: string = "";
  ContactShowName: string = "";
  CompanyShowName: string = "";
  menuModulesList: any = [] = [];
  folderID: number = 0;
  FormReportfolderList: any = [] = [];
  ShowNoRecordFoundForms: boolean = false;
  databaseId: any;
  templateName: string = "";
  aITemplateList: any = [] = [];
  filterText: string = "";
  aiAutomationTemplateID: number = 0;
  showAddUpdateButton: boolean = true;
  PromptTemplateName: string = "";
  PromptTemplateID: number = 0;
  FieldTemplateName: string = "";
  FieldTemplateID: number = 0;

  showSuperAdmin: boolean = false;
  showOrganizationAdmin: boolean = false;
  showOfficeAdmin: boolean = false;
  showUserAdmin: boolean = false;
  UsersList: any[] = [];

  OrgnizationList: any = [] = [];
  OrgnizationListResponseHolder: any = [] = [];

  OrgOfficeList: any = [] = [];
  OrgOfficeListResponseHolder: any = [] = [];

  selectedOrganizationId: number = 0;
  selectedOfficeId: number = 0;
  selecteduserId: string = "";
  rolesAsssign: any[] = [];

  constructor(private formBuilder: FormBuilder, private loaderService: LoaderService,
    private toastr: ToastrService, private statusConst: StatusConstant,
    private reusableClass: ReusableClasses, private dialog: MatDialog,
    private reportsService: ReportService, private encryptionAlgo: EncryptionService) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.organizationId = sessionStorage.getItem('organizationID');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.currentUser = jwt_decode(token);
    var offices = JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID);
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });
  }

  ngOnInit(): void {
    this.menuModulesList = JSON.parse(sessionStorage.getItem('menuModules'));
    var SelectedCore = [];
    var SelectedContact = [];
    var SelectedCompany = [];

    SelectedCore = this.menuModulesList.filter(
      (x) => x.mainModuleName == 'Core'
    );
    if (SelectedCore.length > 0) {
      this.CoreShowName = SelectedCore[0].orgModuleName;     
    }

    SelectedContact = this.menuModulesList.filter(
      (x) => x.mainModuleName == 'Contact'
    );
    if (SelectedContact.length > 0) {
      this.ContactShowName = SelectedContact[0].orgModuleName;      
    }

    SelectedCompany = this.menuModulesList.filter(
      (x) => x.mainModuleName == 'Company'
    );
    if (SelectedCompany.length > 0) {
      this.CompanyShowName = SelectedCompany[0].orgModuleName;   
    }

    this.GetFormUseReports();
    this.rolesAsssign = JSON.parse(sessionStorage.getItem("roles"));

    var superadmin = [];
    // roleLevel:1(Super admin), roleLevel:2(Organization Admin), roleLevel:3(Office Admin),roleLevel:11(User)
    superadmin = this.rolesAsssign.filter((m) => m.roleLevel == RoleLevel.SuperAdmin);
    if (superadmin.length > 0) {
      this.showSuperAdmin = true;
    } else {
      this.showSuperAdmin = false;
    }

    var OrganizationAdmin = [];
    OrganizationAdmin = this.rolesAsssign.filter((m) => m.roleLevel == RoleLevel.OrganizationAdmin ||
      m.roleLevel == RoleLevel.SuperAdmin);
    if (OrganizationAdmin.length > 0) {
      this.showOrganizationAdmin = true;
      this.getOfficeList();
    } else {
      this.showOrganizationAdmin = false;
    }

    var OfficeAdmin = [];
    OfficeAdmin = this.rolesAsssign.filter((m) => m.roleLevel == RoleLevel.OfficeAdmin);
    if (OfficeAdmin.length > 0) {
      this.showOfficeAdmin = true;
    } else {
      this.showOfficeAdmin = false;
    }

    var user = [];
    user = this.rolesAsssign.filter((m) => m.roleLevel == RoleLevel.SuperAdmin ||
      m.roleLevel == RoleLevel.OrganizationAdmin || m.roleLevel == RoleLevel.OfficeAdmin);
    if (user.length > 0) {
      this.showUserAdmin = true;
    } else {
      this.showUserAdmin = false;
    }
  }

  GetFormUseReports() {
    this.loaderService.show();
    var ReqModel = {
      keyword: this.filterText,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId)
    }
    this.reportsService.getFormUseReports(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.aITemplateList = this.responseHolder.data;
          if (this.aITemplateList == null) {
            this.aITemplateList = [];
          }
          if (this.responseHolder.data != null) {
            this.responseHolder.data.map((res) => {
              if (res.email != null) {
                res.email = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.email);
              }
              if (res.firstName != null) {
                res.firstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.firstName);
              }
              if (res.lastName != null) {
                res.lastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.lastName);
              }
              if (res.firstName != null || res.lastName != null) {
                res.fullName = res.firstName + " " + res.lastName;
              }
              return res;
            });
            this.aITemplateList = this.responseHolder.data;
          }
          if (this.aITemplateList.length > 0) {
            this.ShowNoRecordFound = false;
          } else {
            this.ShowNoRecordFound = true;
          }
        }
        else {
          this.ShowNoRecordFound = true;
          this.aITemplateList = [];
          this.loaderService.hide();
        }
      }
      else {
        this.ShowNoRecordFound = true;
        this.aITemplateList = [];
        this.loaderService.hide();
      }
    });
  }




  Search(filterValue) {
    this.filterText = filterValue;
    this.GetFormUseReports();
  }

  clearFilter() {
    this.value = "";
    this.filterText = "";
    this.GetFormUseReports();
  }

  close() {
    this.ParticipantList = [];
    this.dialog.closeAll();
  }

  emailAdvSearch: string = "";
  ProjectName: string = "";
  subject: string = "";
  selectedFormId: number = 0;
  formList: any = [] = [];
  userData: any[] = [];
  sentchecked: boolean = false;
  inProgresschecked: boolean = false;
  completedchecked: boolean = false;
  userListResponseHolder: any = [] = [];
  projectDocuments: any = [] = [];
  ResponseHolderDetails: any = [] = [];
  documentId: number = 0;
  sentby: string = "";
  isAdvancedSearch: boolean = false;
  fromDate: any;
  toDate: any;
  ParticipantList: any = [] = [];

  applyAdvFilter(templateRef: TemplateRef<any>) {
    this.isAdvancedSearch = true;
    this.sentchecked = false;
    this.completedchecked = false;
    this.inProgresschecked = false;
    this.userData = [];
    this.emailAdvSearch = "";
    this.ProjectName = "";
    this.subject = "";
    this.selectedFormId = 0;
    this.fromDate = "";
    this.toDate = "";
    this.formList = [];
    this.documentId = 0
    this.sentby = "";
    this.getOrgListDropdown();
    this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox',
    });
  }

  clear(){
    this.selectedOrganizationId=0;
    this.selectedOfficeId=0;
    this.selecteduserId="";   
  }

  SearchFilter() {
    this.loaderService.show();

    var organizationIds:number=0;
    var officeIds:number=0;
    var UserIds:string="";

    if(this.selectedOrganizationId>0){
      organizationIds = this.selectedOrganizationId;
    }
    if(this.selectedOrganizationId==0){
      organizationIds = Number(this.organizationId);
    }

    if(this.selectedOfficeId>0){
      officeIds = this.selectedOfficeId;
    }
    if(this.selectedOfficeId==0){
      officeIds = 0;//Number(this.myOfficeID);
    }

    if(this.selecteduserId!=""){
      UserIds = this.selecteduserId;
    }
    if(this.selecteduserId==""){
      UserIds = "";//this.currentUser.UID;
    }

    var ReqModel = {
      keyword: this.filterText,
      userID: UserIds,//this.currentUser.UID,
      officeID: officeIds,//this.myOfficeID,
      organizationID: organizationIds,//Number(this.organizationId),
      databaseID: Number(this.databaseId)
    }
    this.reportsService.getFormUseReports(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        this.dialog.closeAll();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.aITemplateList = this.responseHolder.data;
          if (this.aITemplateList == null) {
            this.aITemplateList = [];
          }
          if (this.responseHolder.data != null) {
            this.responseHolder.data.map((res) => {
              if (res.email != null) {
                res.email = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.email);
              }
              if (res.firstName != null) {
                res.firstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.firstName);
              }
              if (res.lastName != null) {
                res.lastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.lastName);
              }
              if (res.firstName != null || res.lastName != null) {
                res.fullName = res.firstName + " " + res.lastName;
              }
              return res;
            });
            this.aITemplateList = this.responseHolder.data;
          }
          if (this.aITemplateList.length > 0) {
            this.ShowNoRecordFound = false;
          } else {
            this.ShowNoRecordFound = true;
          }
        }
        else {
          this.ShowNoRecordFound = true;
          this.aITemplateList = [];
          this.loaderService.hide();
        }
      }
      else {
        this.ShowNoRecordFound = true;
        this.aITemplateList = [];
        this.loaderService.hide();
      }
    });
  }



  getOrgListDropdown() {
    this.reportsService.getOrgs().subscribe(response => {
      if (response) {
        this.OrgnizationListResponseHolder = response;
        if (this.OrgnizationListResponseHolder.status == this.statusConst.statusSuccess) {
          this.OrgnizationList = this.OrgnizationListResponseHolder.data;
        }
      }
    });
  }

  getOfficeList() {
    this.UsersList = [];
    var reqModel = {
      organizationID: Number(this.organizationId)
    }
    this.reportsService.getOrgOffices(reqModel).subscribe(response => {
      if (response) {
        this.OrgOfficeListResponseHolder = response;
        if (this.OrgOfficeListResponseHolder.status == this.statusConst.statusSuccess) {
          this.OrgOfficeList = this.OrgOfficeListResponseHolder.data;
          this.selectedOrganizationId = Number(this.organizationId);
        }
      }
    })
  }


  getOffice(e) {
    this.UsersList = [];
    var reqModel = {
      organizationID: Number(e.value)
    }
    this.reportsService.getOrgOffices(reqModel).subscribe(response => {
      if (response) {
        this.OrgOfficeListResponseHolder = response;
        if (this.OrgOfficeListResponseHolder.status == this.statusConst.statusSuccess) {
          this.OrgOfficeList = this.OrgOfficeListResponseHolder.data;
          this.selectedOrganizationId = Number(e.value);
        }
      }
    })
  }

  selectOffice(e) {
    this.selectedOfficeId = Number(e.value);
    this.UsersList = [];
    this.getUsersList();
  }

  getUsersList() {
    var reqModel = {
      pageIndex: 0,
      pageSize: 5000,
      databaseID: Number(this.databaseId),
      organizationID: this.selectedOrganizationId,
      OfficeIDList: this.OfficeIDList,
      officeID: this.selectedOfficeId,
      userID: this.currentUser.UID
    }
    this.reportsService.getUserList(reqModel).subscribe(response => {
      if (response) {
        this.userListResponseHolder = response.data.userModel;
        if (this.userListResponseHolder != null) {
          this.userListResponseHolder.map((res) => {
            if (res.firstName != null) {
              res.firstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.firstName);
            }
            if (res.lastName != null) {
              res.lastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.lastName);
            }
            return res;
          });
          this.UsersList = response.data.userModel;
        }
      }
    })
  }

  selectUser(e) {
    this.selecteduserId = e.value;
  }

}

